import type { Data } from '@/types/chart';
import { formatNumberLocale } from '@/utils/helpers/formatters';

const DataPoint = ({ point, unit, color }: { point: Data | null; unit?: string; color: string }) => {
  return (
    <div className='mobile-xs:mt-0.5 mobile-xs:items-start flex flex-col items-end whitespace-nowrap'>
      <div className='font-display flex items-baseline gap-0.5'>
        <div className='flex items-center gap-1.5'>
          <svg
            aria-hidden='true'
            width='8'
            height='8'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle
              cx='5'
              cy='5'
              r='3'
              fill={color}
            />
          </svg>
          <span className='text-md'>{formatNumberLocale(point?.value)}</span>
        </div>
        {unit && <span className='translate-y-0.75 text-xs'>{unit}</span>}
      </div>
      {point?.label ? (
        <>
          <span className='text-muted-foreground mt-1 text-xs'>{point.label}</span>
          <span className='text-muted-foreground mt-1 text-xs'>{point.periodLabel}</span>
        </>
      ) : (
        <span className='text-muted-foreground mt-1 text-xs'>{point?.date}</span>
      )}
    </div>
  );
};

export default DataPoint;
